import { ParentModel } from '@blueprint/frontend-basics'
import { IsNotEmpty, IsOptional, IsString, IsUUID } from 'class-validator'

export class CreateShopDto {
  @IsString()
  @IsNotEmpty()
  name: string

  @IsUUID()
  teamId: string

  constructor(name: string = '', teamId: string = '') {
    this.name = name
    this.teamId = teamId
  }
}

export class ShopDto extends ParentModel {
  @IsUUID()
  id?: string

  @IsString()
  @IsNotEmpty()
  name?: string

  @IsOptional()
  creationDate?: string

  constructor() {
    super()
  }
}
